import UserActivitiesConnected from './UserActivitiesConnected'
export default UserActivitiesConnected
